export default __webpack_public_path__ + "static/media/news-1.44630e70.png";